export function normalizeNameToUppercase(value) {
  return String(value ?? '').toUpperCase()
}

export function homologateCode(value) {
  const code = String(value ?? '').replace(/\s+/g, '')
  return code.replace(/^0+/, '')
}
